import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { trackSignupClick } from "@/lib/track";

// Warm/cool spark palettes for the paired fireworks CTA.
export const FX_WARM = ["#f59e0b", "#fb7185", "#f472b6", "#fbbf24", "#fca5a5", "#fdba74"];
export const FX_COOL = ["#22d3ee", "#34d399", "#38bdf8", "#2dd4bf", "#818cf8", "#a78bfa"];

export function FxSparks({ colors }) {
  return Array.from({ length: 12 }).map((_, i) => (
    <span
      key={i}
      className="fw-spark"
      style={{ "--a": `${i * 30}deg`, animationDelay: `${(i % 6) * 0.1}s`, background: colors[i % colors.length] }}
    />
  ));
}

// Fireworks "Sign Up Now" + "See Pricing" pair — both pulse & burst sparks in
// contrasting warm/cool colors. Reused across landing sections.
export default function SectionCTA({ testid = "section-cta", className = "", size = "md" }) {
  const navigate = useNavigate();
  const pad = size === "lg" ? "px-9 py-6 text-base sm:text-lg" : "px-8 py-5 text-base";
  return (
    <div className={`mt-10 flex flex-col sm:flex-row items-center justify-center gap-5 ${className}`} data-testid={testid}>
      <div className="relative inline-block" data-testid={`${testid}-signup-fw`}>
        <FxSparks colors={FX_WARM} />
        <Button
          className={`fw-flash animate-pulse relative z-[2] rounded-full bg-purple-600 hover:bg-purple-700 text-white font-bold shadow-lg shadow-purple-500/40 ${pad}`}
          onClick={() => { trackSignupClick(`${testid}-signup`); navigate("/register"); }}
          data-testid={`${testid}-signup`}
        >
          Sign Up Now <ArrowRight className="w-4 h-4 ml-2" />
        </Button>
      </div>
      <div className="relative inline-block" data-testid={`${testid}-pricing-fw`}>
        <FxSparks colors={FX_COOL} />
        <Button
          className={`fw-flash animate-pulse relative z-[2] rounded-full bg-emerald-600 hover:bg-emerald-700 text-white font-bold shadow-lg shadow-emerald-500/40 ${pad}`}
          onClick={() => navigate("/pricing")}
          data-testid={`${testid}-pricing`}
        >
          See Pricing <ArrowRight className="w-4 h-4 ml-2" />
        </Button>
      </div>
    </div>
  );
}
